class NovaHiddenList extends HTMLElement {
  constructor() {
    super();

    const items = this.querySelectorAll("li");
    const maxItems = 5;

    if (items.length > maxItems) {
      const btnShowMore = document.createElement("div");
      btnShowMore.setAttribute("role", "button");
      btnShowMore.textContent = this.getAttribute("data-show-more-label")
        ? this.getAttribute("data-show-more-label")
        : "Show more";
      btnShowMore.className = "nova-hidden-list__btn--show-more";
      btnShowMore.onclick = () => {
        const isVisible = this.getAttribute("data-nova-hidden-list-visible") === "true";

        if (isVisible) {
          this.setAttribute("data-nova-hidden-list-visible", false);
          btnShowMore.textContent = this.getAttribute("data-show-more-label")
            ? this.getAttribute("data-show-more-label")
            : "Show more";
        } else {
          this.setAttribute("data-nova-hidden-list-visible", true);
          btnShowMore.textContent = this.getAttribute("data-show-less-label")
            ? this.getAttribute("data-show-less-label")
            : "Show less";
        }
      };

      this.appendChild(btnShowMore);
    }
  }
}

if (!customElements.get("nova-hidden-list")) {
  customElements.define("nova-hidden-list", NovaHiddenList);
}
